export default function Menu() {
    // Function to close all dropdowns
    function closeAllDropdowns() {
        document.querySelectorAll('.dropdown-content').forEach(dropdown => {
            dropdown.classList.remove('show');
            const arrow = dropdown.closest('.link').querySelector('.arrow');
            if (arrow) {
                arrow.classList.remove('rotate');
            }
        });
    }

   // Event listener for dropdown buttons
   document.querySelectorAll('.dropdown-btn').forEach(item => {
    item.addEventListener('click', function(event) {
        // Stop propagation to prevent the document click event from firing
        event.stopPropagation();

        // Attempt to find the dropdown content element relative to the clicked button
        var dropdown = this.parentElement.querySelector('.dropdown-content');
        if (!dropdown) {
            console.error("Dropdown content not found.");
            return; // Exit if dropdown content is not found
        }

        var isDropdownOpen = dropdown.classList.contains('show');

        // Close all dropdowns
        closeAllDropdowns();

        // Toggle the clicked dropdown
        if (!isDropdownOpen) {
            dropdown.classList.add('show');
            const arrow = this.querySelector('.arrow');
            if (arrow) {
                arrow.classList.add('rotate');
            } else {
                console.error("Arrow element not found in the dropdown button.");
            }
        }
    });
});

// Event listener for clicking outside the dropdowns
document.addEventListener('click', function(event) {
    closeAllDropdowns();
});



    // MOBILE
    $(document).ready(function(){
        $('#nav-icon3').click(function(){
            $(this).toggleClass('open');
            $('.menu-mobile').toggleClass('open');
            $("#header").toggleClass('open');
        });
    });

    // Scroll down section banner sem card
    let scrollElement = document.querySelector('.down-section');

    if (scrollElement) {
        // Add event listener if the element exists
        scrollElement.addEventListener('click', function() {
            window.scrollBy({
                top: window.innerHeight * 0.9, // 90% of the viewport height
                left: 0,
                behavior: 'smooth'
            });
        });
    } else {
    }
    let scrollElement2 = document.querySelector('.btn-scroll');
    if (scrollElement2) {
        // Add event listener if the element exists
        scrollElement2.addEventListener('click', function() {
            window.scrollBy({
                top: window.innerHeight * 0.9, // 90% of the viewport height
                left: 0,
                behavior: 'smooth'
            });
        });
    } else {
    }

    window.addEventListener('scroll', function() {
        var header = document.getElementById('header');

        if (window.scrollY > 0) {
            header.classList.add('fixed');
        } else {
            header.classList.remove('fixed');
        }
    });
}
